<template>
  <div class="m-layout-content">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'm-main',
  props: {}
}
</script>